import { Component, EventEmitter, Output } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthService } from '@auth0/auth0-angular';
import { CurrentUser } from '@shared/interfaces';
import { CurrentUserService } from '@core/services';

@Component({
    selector: 'app-menu-profile[closePopover]',
    templateUrl: './menu-profile.component.html',
    styleUrls: ['./menu-profile.component.scss'],
})
export class MenuProfileComponent {
    @Output() closePopover: EventEmitter<void> = new EventEmitter<void>();

    accountOverviewUrl = environment.omAccountOverviewUrl;
    readonly bannerSettingsUrl = environment.omBannerSettingsUrl;

    currentUser: CurrentUser | null = null;

    constructor(private auth0: AuthService, private currentUserService: CurrentUserService) {
        this.initializeUser(this.currentUserService.getCurrentUser());
        this.currentUserService.currentUser$.subscribe(user => {
            this.initializeUser(user);
        });
    }

    close(): void {
        this.closePopover.emit();
    }

    initializeUser(user: CurrentUser | null): void {
        this.currentUser = user;
        this.accountOverviewUrl = `${this.accountOverviewUrl}?UserId=${user?.id}`;
    }

    async logout(): Promise<void> {
        const url = `${environment.auth0.logoutUrl}?client_id=${environment.auth0.clientId}&returnTo=${encodeURI(
            environment.auth0.logoutReturnUrl
        )}`;

        await this.auth0.logout({
            openUrl(_url: string) {
                window.location.replace(url);
            },
        });
    }
}
